<template>
    <v-card class="score-chart ma-1">
        <v-container>
            <v-card flat class="ma-1 pa-2 score-trans">
                <v-responsive>
                    <v-card-title dense class="caption-font">Arrivals/upcoming
                        <v-spacer></v-spacer><span class="intro-font"><b>{{this.title}}</b></span>
                    </v-card-title>                                                      
                    <v-card-subtitle>Number of arrivals over the upcoming period</v-card-subtitle>
                    <v-container>
                        <div style="height: 265px; width: 100%;">
                        <canvas id='arrivalsv1-chart1' height="300" style="width:100%;"></canvas>
                        </div>
                    </v-container>
                </v-responsive>
            </v-card>
            <div id="drilldown" :class="{'drill-hide': !open, 'drill-show': open}" class="drill-down">
                <div class="drill-header">
                    <div>Week {{this.week}}</div>
                    <div>
                        <v-icon size="20" @click.stop="test()">mdi-close</v-icon>
                    </div>
                </div>
                <div class="drill-grid" v-for="(day, i) in weekdata[this.week]" :key="i">                    
                    <div>{{ day.day }}</div>
                    <div>{{ day.date }}</div>
                    <div class="push-right">{{ day.arrivals }}</div>
                </div>
            </div>
        </v-container>
    </v-card>
</template>

<script>

    import mxarrivalschart from '../mixins/arrivals_chart_V1';

    import { Chart, registerables } from 'chart.js'
    Chart.register(...registerables)    

    import {bus} from "../../../../main";

    export default {
        data() {
            return {
                arrivals: [],
                chart: null,
                week: 0,
                open: false,
                weekdays: [],
                weekdata: {},
            }
        },
        created(){ // set up event bus listener here on created event
            this.getArrivalData('load');
            bus.$on("refresh", (data) => {
                console.log(data)
                this.getArrivalData('refresh');                
            });
        },                     
        mixins:[mxarrivalschart],
        methods:{
            refreshChart(object){
                this.chart.data.labels = object.data.labels;
                let i = 0;
                this.chart.data.datasets.forEach((dataset) => {
                   dataset.data = object.data.datasets[i].data;
                   i++;
                });
                this.chart.options = object.options;
                this.chart.update();
            },
            getArrivalData(param){         
                this.$axios
                    .post("ares/json/ares/syst/dashboard/getArrivalsv3.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getArrivals"
                    },
                    })
                    .then(res => {
                        if (res.data.error) {
                            console.log(res.data.error);
                        } else {
                            this.weekdata = res.data.getWeekDetails
                            this.arrivals = res.data.getArrivals  
                            // console.log(this.weekdata[5])
                            if(param ==='load'){
                                const ctx = document.getElementById('arrivalsv1-chart1').getContext('2d');
                                this.chart = new Chart(ctx, this.createBarData(this.arrivals)); // horizontalBar, bar                                
                            } else {
                                this.refreshChart(this.createBarData(this.arrivals));
                            }
                        }
                    })
                    .finally(() => {
                });
            },      
            showDrillDown(x, y){
                console.log(x, y)
                let drilldown = document.getElementById('drilldown');
                drilldown.style.position = "absolute"
                drilldown.style.left = (x-50) +'px'
                drilldown.style.top = (y-30)+'px'
                this.weekdays = this.weekdata[this.week]
            },    
            test(){
                console.log('click');
                this.open=false
                console.log(this.open)
            }   
        }
    }
</script>

<style scoped>
    .score-chart {
        background: url('../assets/not_a_sunset.png') !important;
        background-size: cover !important;
    }
    .intro-font {
        font-size: 20px;
    }
    .caption-font {
        font-size: 30px;
        font-weight: bold;
    }
    .score-trans {
        background: transparent !important;
    }
    .drill-down{
        padding: 4px;
        border: 1px solid;
        border-radius: 5px;
        font-size: 8pt;
        background: #ffff;
    }
    .drill-header{
        cursor: pointer;
        display: flex;
        flex-direction: row;
        align-items: center;
        font-weight: 600;
        font-size: 10pt;
        justify-content: space-between;
        margin-top: 1px;
        margin-bottom: 5px;
    }
    .drill-grid{
        display: grid;
        grid-template-columns: 30px 50px 30px; 
    }
    .drill-hide{
        display: none;
    }
    .drill-show{
        display: unset;
    }
    .push-right{
        margin-left: auto;
    }
</style>